import SessionStore from '../stores/SessionStore.js'
import useStores from './useStores.js';
import PageStart from './PageStart.js';
import PageNote from './PageNote.js';
import PageSuccess from './PageSuccess.js';
import PageDone from './PageDone.js';

const {
  PAGE_START,
  PAGE_NOTE,
  PAGE_SUCCESS,
  PAGE_DONE
} = SessionStore.PAGES;

function Flashcards() {
  useStores([SessionStore]);

  const page = SessionStore.getPage();
  switch (page) {
    case PAGE_START:
      return PageStart();
    case PAGE_NOTE:
      return PageNote();
    case PAGE_SUCCESS:
      return PageSuccess();
    case PAGE_DONE:
      return PageDone();
    default:
      return (<p>Unknown page {page}</p>);
  }
}

export default Flashcards;
